import React from "react"
import { useTranslations } from "next-intl"

import { ReducedProductData } from "@/lib/storefront/product/product"
import { cn } from "@/lib/utils"
import { calculateAvailabilityData } from "@/components/ui/helpers/product-availability-helper"
import ImageWithFallback from "@/components/storyblok/common/ImageWithFallback"

export function ProductCardDeliveryInfo(props: {
  productData: ReducedProductData | undefined
  isoLocale: string
  compact: boolean | undefined
  isListView?: boolean
}) {
  const t = useTranslations("storefront")

  const availabilityData = calculateAvailabilityData(props.isoLocale, props.productData, /*props.standardVariant,*/ t)
  const availabilityText = availabilityData.availabilityText ? "(" + availabilityData.availabilityText + ")" : ""

  return (
    <>
      <div className={cn("flex items-center justify-start gap-2 text-balance", { "gap-1": props.compact })}>
        <img
          src={"/img/delivery.svg"}
          className={cn("aspect-square h-8 object-contain lg:h-6 xl:h-8", {
            "@xl:!h-8 @xl:!aspect-[unset]": props.isListView,
            "!h-4": props.compact,
          })}
          alt={""}
        />
        <div className={"flex flex-col items-start justify-center"}>
          {props.productData?.availability === true ? (
            <>
              <p className={"text-xs leading-tight lg:text-[0.65em] xl:text-xs"}>
                {availabilityData.immediatelyAvailable ? (
                  t("product.available")
                ) : (
                  <>
                    <span className={cn({ "@2xl:hidden": props.isListView })}>{t("product.free_shipping")}</span>
                    {props.isListView && (
                      <span className={cn({ "hidden @2xl:inline": props.isListView })}>
                        {t("product.fast_shipping")}
                      </span>
                    )}
                  </>
                )}
              </p>
              <p className={"text-xs leading-tight lg:text-[0.65em] xl:text-xs"}>{availabilityText}</p>
            </>
          ) : (
            <p className={"text-xs leading-tight lg:text-[0.65em] xl:text-xs"}>{t("product.delivery_time_unknown")}</p>
          )}
        </div>
      </div>
      {props.isListView && (
        <div
          className={cn("hidden items-center justify-start gap-2 text-balance @2xl:flex", { "gap-1": props.compact })}
        >
          <img className={cn("h-8")} alt={""} src={"/img/delivery_free.svg"} />
          <div className={"flex flex-col items-start justify-center"}>
            <p className={"text-xs leading-tight lg:text-[0.65em] xl:text-xs"}>{t("product.free_shipping")}</p>
          </div>
        </div>
      )}
    </>
  )
}
